import { css } from 'styled-components';
import { rgba } from 'polished';
import { combineValues } from '@cld/component-theme';
import { t } from '../CodeSnippetTheme';

const selectionColor = css`
  ${combineValues(t.code.selection, (text: string) => rgba(text, 0.2))}
`;
/**
 * Token grouping inspired by Material Light / Dark PrismJS themes by Oleg Dutchenko
 * https://github.com/PrismJS/prism-themes/blob/master/themes/prism-material-light.css
 * https://github.com/PrismJS/prism-themes/blob/master/themes/prism-material-dark.css
 */
export default css`
  code,
  pre {
    color: ${t.code.syntax.character};
    font-family: 'Menlo', Courier, monospace;
    direction: ltr;
    text-align: left;
    white-space: pre;
    word-spacing: normal;
    word-break: normal;
    font-size: ${t.code.fontSize};
    line-height: ${t.code.lineHeight};
    tab-size: 4;
    hyphens: none;
    min-height: 100%;
  }

  pre::selection,
  pre ::selection,
  code::selection,
  code ::selection {
    background: ${selectionColor};
  }

  /* Code blocks */
  pre {
    padding: ${t.code.padding};
    margin: 0;
    overflow: auto;
    background-color: ${t.code.syntax.background};
  }

  /* Inline code */
  :not(pre) > code {
    padding: ${t.code.padding};
    background-color: ${t.code.syntax.background};
  }

  .token.attr-name,
  .token.bultin,
  .token.class {
    color: ${t.code.syntax.attributeName};
  }

  .token.comment,
  .token.doctype,
  .token.prolog {
    color: ${t.code.syntax.comment};
  }

  .token.cdata,
  .token.char,
  .token.inserted,
  .token.property {
    color: ${t.code.syntax.character};
  }

  .token.operator,
  .token.punctuation {
    color: ${t.code.syntax.operator};
  }

  .token.class-name,
  .token.hexcode,
  .token.regex {
    color: ${t.code.syntax.regex};
  }

  .token.attr-value,
  .token.attribute,
  .token.pseudo-class,
  .token.pseudo-element,
  .token.string {
    color: ${t.code.syntax.attributeValue};
  }

  .token.atrule,
  .token.boolean,
  .token.constant,
  .token.function,
  .token.id,
  .token.important,
  .token.keyword,
  .token.symbol {
    color: ${t.code.syntax.keyword};
  }

  .token.number,
  .token.unit {
    color: ${t.code.syntax.number};
  }

  .token.deleted,
  .token.entity,
  .token.selector,
  .token.tag,
  .token.url,
  .token.variable {
    color: ${t.code.syntax.tag};
  }

  .token.namespace {
    opacity: 0.7;
  }

  .token.important,
  .token.bold {
    font-weight: bold;
  }

  .token.italic {
    font-style: italic;
  }
`;
